<template>
  <div class="date-field">
    <v-menu
      v-model="showDatePicker"
      :close-on-content-click="false"
      :nudge-right="40"
      :nudge-top="25"
      transition="scale-transition"
      offset-y
      max-width="290"
      min-width="290"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="formattedValue"
          :label="label"
          :rules="rules"
          :loading="loading"
          :disabled="disabled"
          prepend-inner-icon="mdi-calendar"
          readonly
          clearable
          outlined
          v-bind="attrs"
          v-on="on"
          @click:clear="$emit('input', null)"
        ></v-text-field>
      </template>

      <v-card>
        <v-date-picker
          :value="value"
          :locale="$i18n && $i18n.locale ? $i18n.locale : 'ru'"
          first-day-of-week="1"
          no-title
          @input="onPickerInput"
        ></v-date-picker>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
  export default {
    name: 'DateField',
    props: {
      value: {
        type: String,
        default: null,
      },
      label: {
        type: String,
        default: '',
      },
      rules: {
        type: Array,
        default: () => [],
      },
      loading: Boolean,
      disabled: Boolean,
    },
    data () {
      return {
        showDatePicker: false,
      }
    },
    computed: {
      formattedValue () {
        if (!this.value) return ''
        const date = new Date(this.value)
        if (Number.isNaN(date.getTime())) return ''
        return date.toLocaleDateString('ru-RU', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        })
      },
    },
    methods: {
      onPickerInput (val) {
        this.$emit('input', val)
        this.showDatePicker = false
      },
    },
  }
</script>

<style scoped>
</style>
